var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.room && _vm.room.smileys_enabled)?_c('div',{staticClass:"smileys-wrapper pa-3"},_vm._l((_vm.smileys),function(smiley){return _c('div',{key:smiley,staticClass:"smiley",class:{ disabled: _vm.disabled },domProps:{"innerHTML":_vm._s(smiley)},on:{"click":() => _vm.sendSmiley(smiley)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }